// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1WQUX","left":"InfoRow_left__Y4GWS"};